import { FormEvent, useState } from "react";
import Preloader from "../../../app-components/preloader/Preloader";
import { Link } from "react-router-dom";
import apiClient from "../../../api-services/ApiClient";
import { SITELINKS } from "../../../app-routes/links";
import { LuArrowLeft, LuCheck } from "react-icons/lu";
import AuthLayout from "../common/AuthLayout";

const ResetPassword = () => {
  const [formData, setLoginData] = useState({
    email: "",
  });

  const [serverError, setServerError] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [isSuccessful, setIsSuccessful] = useState<boolean>(false);

  // handle-input-change
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setLoginData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleRequest = async (e: FormEvent) => {
    e.preventDefault();
    setServerError("");

    if (formData.email) {
      setLoading(true);
      try {
        await apiClient.post(
          "Authentication/ResendPasswordResetLink",
          formData
        );
        setIsSuccessful(true);
      } catch (error: any) {
        setServerError(JSON.stringify(error));
      } finally {
        setLoading(false);
      }
    } else {
      setServerError("Email is required");
    }
  };

  return (
    <AuthLayout title="Reset Password">
      <p className="flex-col text-xs text-gray-600 px-12 text-center">
        Enter your email address to reset your password
      </p>

      {isSuccessful ? (
        <div className="p-12 pt-5 flex-col justify-center text-center items-center">
          <div className="flex justify-center text-center items-center mt-5">
            <LuCheck className="text-[150px] text-gray-50 bg-green-600 rounded-full p-6" />
          </div>

          <p className="flex-col text-green-700 text-sm mt-5 text-center">
            You have successfully activated your account
          </p>

          <Link
            to={SITELINKS.MAIN}
            className="flex-col block mt-5 text-green-600 font-medium text-sm "
          >
            Proceed to Login
          </Link>
        </div>
      ) : (
        <form
          className="p-12 pt-3"
          onSubmit={handleRequest}
          autoComplete="off"
          autoCorrect="off"
        >
          <div className="mt-4">
            <Link
              className="text-xs font-medium items-center flex gap-2 text-red-600"
              to={SITELINKS.MAIN}
            >
              <LuArrowLeft className="text-lg" />
              <span>Go to login</span>
            </Link>
          </div>

          <p className="text-red-600 text-[12px] text-center mb-4">
            {serverError}
          </p>
          {/* email input */}
          <div className="flex flex-col text-xs mb-4">
            <label htmlFor="userID" className="mb-1">
              Email
            </label>
            <input
              name="email"
              onChange={handleInputChange}
              className={`w-full bg-gray-50 border border-solid border-gray-400 text-black p-3 rounded-lg focus:outline-1 focus:outline focus:outline-gray-600 font-normal`}
              placeholder="Enter your email"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="disabled:bg-gray-200 disabled:text-gray-600 mt-5 bg-red-600 text-white px-20 py-3 shadow-md hover:shadow-xl w-full rounded-xl text-sm"
          >
            {loading ? "Loading..." : "Reset Password"}
          </button>
        </form>
      )}

      <Preloader loading={loading} />
    </AuthLayout>
  );
};

export default ResetPassword;
